import React from 'react';
import styles from './notFound.module.scss';
import { IconProhibited } from '@yoti/ui-kit-components-react/globals';

const NotFound: React.FC = () => (
    <div className={styles['not-found']}>
        <IconProhibited className={styles['not-found__icon']} />
        <div className={styles['not-found__text']}>Page not found</div>
    </div>
);

export default NotFound;
